import { ValidationError } from 'yup';

import { yup } from '~/adapters/YupAdapter';
import { i18n } from '~modules/lang/LangAdapter';
import { SurveyResultCommentFormField } from '~modules/surveys/forms/SurveyResultCommentForm';

export const surveyCommentsValidationSchema: any = yup.object().shape({
  [SurveyResultCommentFormField.comments]: yup
    .object()
    .required()
    .test('all-values-are-strings', '', function (comments) {
      if (!comments || typeof comments !== 'object') {
        return true;
      }
      const errors: ValidationError[] = [];

      Object.entries(comments).forEach(([key, value]) => {
        if (typeof value !== 'string' || value.trim() === '') {
          errors.push(
            this.createError({
              path: `${this.path}.${key}`,
              message: i18n.t('error.required', { ns: 'common' }),
            }),
          );
        }
      });

      if (errors.length > 0) {
        throw new yup.ValidationError(errors);
      }

      return true;
    }),
});
